export const UPDATE_DIMENSIONS = 'UPDATE_DIMENSIONS';
export const UPDATE_VIEWPORT = 'UPDATE_VIEWPORT';
export const UPDATE_API_PROPS = 'UPDATE_API_PROPS';
export const UPDATE_TILE_JSON = 'UPDATE_TILE_JSON';



// WEBPACK FOOTER //
// ./src/modules/map/action-types.js